import { gql } from '@apollo/client';

export const GET_WIDGET_INFO = gql`
  query GetWidgetInfo($id: ID!) {
    hotel(id: $id) {
      id
      knownWidgetHosts
    }
  }
`;
